// Five fixed columns — no column picker, no dynamic splicing.
// Keys passed to `useResizableColumns` so each column resolves to a
// `max-content` track at rest and a `<userWidth>px` track once the user
// drags the resize handle. See PunchupTable CLAUDE.md → "Column width
// strategy" for the full model.
export const VIEW_RESPONSES_KEYS = ['date', 'question', 'answer', 'fullName', 'email', 'phone'] as const;
